import React from 'react';
import styles from './LegalPage.module.css';

export default function RegulaminPage() {
  return (
    <div className={styles.page}>
      <div className={styles.inner}>
        <p className={styles.eyebrow}>Dokument prawny</p>
        <h1>Regulamin serwisu Nieruchomy.pl</h1>
        <p className={styles.updated}>Obowiązuje od: 1 stycznia 2025 r.</p>

        <section>
          <h2>§1. Postanowienia ogólne</h2>
          <p>1. Serwis Nieruchomy.pl (dalej: „Serwis") jest niekomercyjną platformą ogłoszeniową umożliwiającą bezpłatną publikację i przeglądanie ofert nieruchomości, prowadzoną przez osobę prywatną.</p>
          <p>2. Operatorem Serwisu jest osoba fizyczna działająca jako administrator (dalej: „Administrator"), kontakt: kontakt@nieruchomy.pl.</p>
          <p>3. Serwis jest w pełni bezpłatny — nie pobiera żadnych opłat od użytkowników ani od ogłoszeniodawców. Administrator nie czerpie dochodów z działalności Serwisu.</p>
          <p>4. Korzystanie z Serwisu oznacza akceptację niniejszego Regulaminu.</p>
          <p>5. Regulamin dostępny jest pod adresem nieruchomy.pl/regulamin.</p>
        </section>

        <section>
          <h2>§2. Rejestracja i konto użytkownika</h2>
          <p>1. Korzystanie z pełnej funkcjonalności Serwisu (dodawanie ogłoszeń) wymaga rejestracji konta.</p>
          <p>2. Rejestracja wymaga podania aktywnego adresu e-mail oraz weryfikacji konta za pomocą kodu weryfikacyjnego.</p>
          <p>3. Użytkownik zobowiązany jest do podania prawdziwych danych kontaktowych.</p>
          <p>4. Użytkownik odpowiada za bezpieczeństwo swojego hasła i poufność danych logowania.</p>
          <p>5. Administrator zastrzega sobie prawo do zablokowania lub usunięcia konta użytkownika naruszającego Regulamin.</p>
        </section>

        <section>
          <h2>§3. Zasady publikacji ogłoszeń</h2>
          <p>1. Dodawanie ogłoszeń jest całkowicie bezpłatne i takim pozostanie.</p>
          <p>2. Użytkownik może publikować ogłoszenia dotyczące nieruchomości, których jest właścicielem lub do których sprzedaży/wynajmu jest uprawniony.</p>
          <p>3. Każde ogłoszenie przed publikacją podlega ręcznej weryfikacji przez Administratora. Administrator zastrzega sobie prawo do odrzucenia ogłoszeń niespełniających wymogów Regulaminu.</p>
          <p>4. Ogłoszenie musi zawierać rzetelne i zgodne z prawdą informacje.</p>
          <p>5. Zabrania się publikowania ogłoszeń:</p>
          <ul>
            <li>zawierających treści niezgodne z prawem polskim,</li>
            <li>o charakterze reklamowym niezwiązanym z nieruchomościami,</li>
            <li>powielających tę samą nieruchomość wielokrotnie,</li>
            <li>zawierających dane osobowe osób trzecich bez ich zgody,</li>
            <li>wprowadzających w błąd co do stanu, ceny lub lokalizacji nieruchomości.</li>
          </ul>
          <p>6. Do ogłoszenia można dodać maksymalnie 3 zdjęcia w formatach JPG, PNG lub WebP, każde o rozmiarze do 8 MB.</p>
          <p>7. Administrator może usunąć ogłoszenie naruszające Regulamin bez wcześniejszego powiadomienia użytkownika.</p>
        </section>

        <section>
          <h2>§4. Odpowiedzialność</h2>
          <p>1. Administrator nie ponosi odpowiedzialności za treść ogłoszeń publikowanych przez użytkowników.</p>
          <p>2. Administrator nie jest stroną transakcji zawieranych między użytkownikami i nie pośredniczy w żadnych płatnościach.</p>
          <p>3. Serwis jest udostępniany nieodpłatnie w trybie „tak jak jest" (as-is). Administrator dokłada starań, aby działał poprawnie, jednak nie gwarantuje ciągłości działania ani braku błędów.</p>
          <p>4. Ponieważ Serwis jest niekomercyjny i bezpłatny, Administrator nie ponosi odpowiedzialności za szkody wynikłe z korzystania lub niemożności korzystania z Serwisu.</p>
          <p>5. Użytkownik korzysta z Serwisu na własne ryzyko i odpowiedzialność.</p>
        </section>

        <section>
          <h2>§5. Prawa autorskie</h2>
          <p>1. Projekt graficzny, kod źródłowy i znaki towarowe Serwisu należą do Administratora.</p>
          <p>2. Użytkownik udziela Administratorowi niewyłącznej, nieodpłatnej licencji na wyświetlanie zdjęć i treści opublikowanych w ogłoszeniach w ramach Serwisu, przez czas ich publikacji.</p>
          <p>3. Użytkownik oświadcza, że posiada prawa do publikowanych zdjęć i treści.</p>
        </section>

        <section>
          <h2>§6. Reklamacje i kontakt</h2>
          <p>1. Uwagi, pytania i zgłoszenia dotyczące Serwisu można kierować na adres e-mail: kontakt@nieruchomy.pl.</p>
          <p>2. Administrator odpowie na wiadomość w miarę możliwości, w rozsądnym terminie.</p>
          <p>3. Ponieważ Serwis jest prowadzony nieodpłatnie przez osobę prywatną, Administrator nie gwarantuje formalnego terminu odpowiedzi.</p>
        </section>

        <section>
          <h2>§7. Zmiany Regulaminu</h2>
          <p>1. Administrator zastrzega sobie prawo do zmiany Regulaminu.</p>
          <p>2. O istotnych zmianach zarejestrowani użytkownicy zostaną poinformowani drogą e-mailową z 14-dniowym wyprzedzeniem.</p>
          <p>3. Dalsze korzystanie z Serwisu po wejściu zmian w życie oznacza ich akceptację.</p>
        </section>

        <section>
          <h2>§8. Postanowienia końcowe</h2>
          <p>1. Prawem właściwym dla niniejszego Regulaminu jest prawo polskie.</p>
          <p>2. W sprawach nieuregulowanych Regulaminem zastosowanie mają przepisy polskiego Kodeksu Cywilnego oraz ustawy o świadczeniu usług drogą elektroniczną.</p>
          <p>3. Jeśli którekolwiek z postanowień Regulaminu jest nieważne, pozostałe pozostają w mocy.</p>
        </section>
      </div>
    </div>
  );
}
